import { useCallback, useEffect, useRef, useState } from 'react';
import { getWallets } from '../api/wallets.api';
import type { WalletsPage } from '../types/wallet.types';

export function useWallets(page: number, search = '') {
  const [wallets, setWallets] = useState<WalletsPage['wallets']>([]);
  const [meta, setMeta] = useState<WalletsPage['meta']>({ page, limit: 20, total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);

  const loadWallets = useCallback(() => {
    setLoading(true);
    setError(null);
    return getWallets(page, 20, search)
      .then((data) => {
        if (!mountedRef.current) return;
        setWallets(data.wallets);
        setMeta(data.meta);
      })
      .catch(() => {
        if (mountedRef.current) setError('خطا در دریافت فهرست کیف پول‌ها');
      })
      .finally(() => {
        if (mountedRef.current) setLoading(false);
      });
  }, [page, search]);

  useEffect(() => {
    mountedRef.current = true;
    loadWallets();
    return () => { mountedRef.current = false; };
  }, [loadWallets]);

  return { wallets, meta, loading, error, refetch: loadWallets };
}
